import { render, staticRenderFns } from "./AgentsTradesmanList.vue?vue&type=template&id=519dd3e7&"
import script from "./AgentsTradesmanList.vue?vue&type=script&lang=js&"
export * from "./AgentsTradesmanList.vue?vue&type=script&lang=js&"
import style0 from "./AgentsTradesmanList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports